<template>
  <div id="app">
    <div class="error" v-if="$store.state.error">
      <div class="container">{{$store.state.error}}</div>
    </div>
    <div v-else-if="$store.state.loaded">
      <SubscriptionProgress />
      <router-view />
    </div>
    <div class="spinner-border" role="status" v-else>
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
import SubscriptionProgress from "@/components/SubscriptionProgress.vue";

export default {
  components: {
    SubscriptionProgress
  },
  computed: {
    selectedPackage() {
      return this.$store.getters.selectedPackage;
    }
  },
  mounted() {
    // Maintain 'id', 'email' and 'uid' query parameters
    this.$router.beforeEach((to, from, next) => {
      if (to.query.id === undefined && to.query.email === undefined) {
        next({
          ...to,
          query: {
            ...to.query,
            id: to.query.id || from.query.id,
            email: to.query.email || from.query.email,
            uid: to.query.uid || from.query.uid
          }
        });
      } else {
        next();
      }
    });

    this.$router.afterEach(() => {
      window.scrollTo({
        top: 0,
        left: 0
      });
      if (
        this.$store.state.loaded &&
        !this.$store.state.subscriberData.Submitted
      ) {
        // Submit changes to the API
        this.$store.dispatch("saveState");
      }
    });

    // Load data
    this.$store.commit("setSubscriberId", {
      id: this.$route.query.id,
      email: this.$route.query.email,
      uid: this.$route.query.uid
    });
    this.$store.dispatch("loadState");
  },
  watch: {
    selectedPackage(newVal, oldVal) {
      if (!this.$store.state.loaded) {
        return;
      }

      const getOption = this.$store.getters.getOption;
      const data = this.$store.state.subscriberData;
      // TODO: add MIN value?
      if (!getOption("experience-center")) {
        data.ExperienceCenter = false;
      }
      // Reset Career Expo
      if (!this.$store.getters.hasEvent("career-expo")) {
        data.SpeedDates = false;
        data.ExtraWorkers = 0;
        data.ExtraTables = 0;
        data.ExtraStools = 0;
      } else {
        data.ExtraWorkers = Math.min(
          data.ExtraWorkers,
          getOption("extra-employee").max || 0
        );
        data.ExtraTables = Math.min(
          data.ExtraTables,
          getOption("extra-table").max || 0
        );
        data.ExtraStools = Math.min(
          data.ExtraStools,
          getOption("extra-barstool").max || 0
        );
      }
      // Reset Interviewing Days
      if (!this.$store.getters.hasEvent("interviewing-days")) {
        data.Interviews = 0;
        data.Lunches = 0;
        data.Diners = 0;
        data.Cases = 0;
      } else {
        data.Interviews = Math.min(
          data.Interviews,
          getOption("interview").max || 0
        );
        data.Lunches = Math.min(data.Lunches, getOption("lunch").max || 0);
        data.Diners = Math.min(data.Diners, getOption("dinner-drink").max || 0);
        data.Cases = Math.min(data.Cases, getOption("company-case").max || 0);
      }
    }
  }
};
</script>
